module.exports = __webpack_public_path__ + "media/images/mobile/solutions/1-d4431373789e81b87dcc2076d32a554a.jpg";